import { createFormAction } from 'redux-form-saga';
import { LOGIN } from './types';

export const login = createFormAction(LOGIN)
